import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "bs-table" }
const _hoisted_2 = {
  key: 0,
  scope: "col",
  style: {"text-align":"right"}
}
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("thead", null, [
      _createElementVNode("tr", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (col) => {
          return (_openBlock(), _createElementBlock("th", {
            scope: "col",
            key: col.key
          }, _toDisplayString(col.name), 1))
        }), 128)),
        (_ctx.$slots['actions'])
          ? (_openBlock(), _createElementBlock("th", _hoisted_2, "Действия"))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("tbody", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row, i) => {
        return (_openBlock(), _createElementBlock("tr", {
          key: `row-${i}`
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (col) => {
            return (_openBlock(), _createElementBlock("td", {
              key: `row-${i}-col-${col.key}`,
              class: _normalizeClass({
                        'col--center': col.align && col.align === 'center',
                        'col--right': col.align && col.align === 'right'
                    })
            }, [
              (_ctx.$slots[col.key])
                ? _renderSlot(_ctx.$slots, col.key, {
                    key: 0,
                    row: row,
                    column: col
                  })
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(row[col.key]), 1)
                  ], 64))
            ], 2))
          }), 128)),
          (_ctx.$slots['actions'])
            ? (_openBlock(), _createElementBlock("td", _hoisted_3, [
                _renderSlot(_ctx.$slots, "actions", { row: row })
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ]))
}